export const TABELA_TITLE = "Distribuição por coletor e mensalização";
export const TABELA_LABEL = "Coletores e mensalização da projeção";
export const COLETOR_COLUNA = "Coletor";
export const TOTAL_COLUNA = "Total (R$)";
export const TOTAL_GERAL = "Total";
export const INICIO_MARCA = "Início";
export const SEM_DISTRIBUICAO = "sem distribuição";
export const ERRO_PREVIA_TITLE = "Não foi possível atualizar a prévia.";
export const CALCULANDO_LABEL = "Calculando a prévia…";
export const COLETOR_PENDENTE = "Pendente de cotação";
